import styled from '@emotion/styled';
import { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';
import { BrandContext } from '../../contexts/BrandContext';
import { HeaderContext } from '../../contexts/HeaderContext';
import { FrontHeader, FrontMenu } from '../../feature';
import { themeVars } from '../../ui-components/theme/theme';

const AuthBrandRoute = ({ noRedirect = false }: { noRedirect?: boolean }) => {
  const {
    isLoading,
    loading: isAuthLoading,
    isAPIAuthenticated,
    isLoggedIn,
  } = useContext(AuthContext);
  const navigate = useNavigate();

  //Will wait for BrandContext & HeaderContext to finish initializing before rendering
  const { init: brandLoaded, hasSelectedBrand } = useContext(BrandContext);
  const { init: headerLoaded } = useContext(HeaderContext);

  useEffect(() => {
    if (isLoading || isAuthLoading || !headerLoaded || !brandLoaded) return;
    if (!hasSelectedBrand()) {
      if (!isAPIAuthenticated) {
        if (!noRedirect) {
          navigate(isLoggedIn ? '/verify' : '/login');
        }
      } else {
        if (!noRedirect) {
          navigate('/brand');
        }
      }
    }
  }, [
    brandLoaded,
    hasSelectedBrand,
    headerLoaded,
    isAPIAuthenticated,
    isAuthLoading,
    isLoading,
    isLoggedIn,
    navigate,
    noRedirect,
  ]);

  if (isLoading || isAuthLoading || !headerLoaded || !brandLoaded || !hasSelectedBrand()) {
    return <></>;
  }

  return (
    <Wrapper>
      <FrontMenu />
      <BodyWrapper>
        <FrontHeader />
        {/*<Header />*/}
        <Content>
          <Outlet />
        </Content>
      </BodyWrapper>
    </Wrapper>
  );
};

export default AuthBrandRoute;

const Wrapper = styled.div`
  background: ${themeVars.colors.titan100};
  display: flex;
  width: 100vw;
`;

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  background-color: #fff;
  margin: 4px 4px 4px 0;
  overflow: auto;
  border-radius: 16px;
  border: 1px solid ${themeVars.colors.titan200};
`;

const Content = styled.div`
  min-height: 50vh;
  overflow: auto;
  padding: 0 40px 150px 40px;
`;
